import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  modalTitle: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.title',
    defaultMessage: 'Sort and Filter',
  },
  sortByHeader: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortBySection.header',
    defaultMessage: 'Sort by',
  },
  filterByHeader: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.filterBySection.header',
    defaultMessage: 'Filter by',
  },
  clearAllButtonLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.clearAllButton.label',
    defaultMessage: 'Clear all',
  },
  cancelButtonLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.cancelButton.label',
    defaultMessage: 'Cancel',
  },
  sortByNameAscending: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByNameAscendingButton.label',
    defaultMessage: 'Name (A-Z)',
  },
  sortByNameAscendingAriaLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByNameAscendingButton.aria-label',
    defaultMessage: 'name descending radio',
    description: 'Accessible (screen reader) label for "name descending" filter',
  },
  sortByNewest: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByNewestButton.label',
    defaultMessage: 'Newest',
  },
  sortByNewestAriaLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByNewestButton.label-label',
    defaultMessage: 'date added descending radio',
    description: 'Accessible (screen reader) label for "date added descending" filter',
  },
  sortBySizeDescending: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortBySizeDescendingButton.label',
    defaultMessage: 'File size (High to low)',
  },
  sortBySizeDescendingAriaLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortBySizeDescendingButton.aria-label',
    defaultMessage: 'file size descending radio',
    description: 'Accessible (screen reader) label for "file size descending" filter',
  },
  sortByNameDescending: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByNameDescendingButton.label',
    defaultMessage: 'Name (Z-A)',
  },
  sortByNameDescendingAriaLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByNameDescendingButton.aria-label',
    defaultMessage: 'name ascending radio',
    description: 'Accessible (screen reader) label for "name ascending" filter',
  },
  sortByOldest: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByOldestButton.label',
    defaultMessage: 'Oldest',
  },
  sortByOldestAriaLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortByOldestButton.aria-label',
    defaultMessage: 'date added ascending radio',
    description: 'Accessible (screen reader) label for "date added ascending" filter',
  },
  sortBySizeAscending: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortBySizeAscendingButton.label',
    defaultMessage: 'File size (Low to high)',
  },
  sortBySizeAscendingAriaLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortBySizeAscendingButton.aria-label',
    defaultMessage: 'file size ascending radio',
    description: 'Accessible (screen reader) label for "file size ascending" filter',
  },
  applySortButton: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.applyySortButton.label',
    defaultMessage: 'Apply',
  },
});

export default messages;
